<template>
  <div class="divider" />
</template>

<script>
export default {
  name: 'VDivider'
}
</script>
<style scoped>
.divider {
    width: 1px;
    height: 100%;
    min-height: 43px;
    background: #484848 0% 0% no-repeat padding-box;
    opacity: 0.1;
}
</style>
